import { render, staticRenderFns } from "./Configuration.vue?vue&type=template&id=04a22bef&scoped=true&"
import script from "./Configuration.vue?vue&type=script&lang=ts&"
export * from "./Configuration.vue?vue&type=script&lang=ts&"
import style0 from "./Configuration.vue?vue&type=style&index=0&id=04a22bef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a22bef",
  null
  
)

export default component.exports